import React, { useState } from 'react';
import { FestivalHeader, Loading } from '../controls';
import FilterableTable from '../table';
import Portal from '../modal';
import { SponsorForm } from './';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import {
  useRemoveSponsorMutation,
  useSaveSponsorMutation,
  useSponsorsQuery,
} from '@/queries/sponsors';

export function Sponsors() {
  const festival = useFestivalWorkspaceStore((s) => s.festival);
  const festivalId = festival?.festivalId;

  const sponsorsQ = useSponsorsQuery(festivalId);
  const saveMutation = useSaveSponsorMutation(festivalId);
  const removeMutation = useRemoveSponsorMutation(festivalId);

  const sponsors = sponsorsQ.data ?? [];
  const loading =
    festivalId == null || sponsorsQ.isPending || sponsorsQ.isFetching;

  const [showModal, setShowModal] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState({});

  const buildColumnDefinitions = () => {
    var columnDefs = {};
    columnDefs.sponsorName = {
      header: 'Sponsor Name',
      filterable: true,
      sortable: true,
      showViewLink: false,
      handleClick: true,
    };
    return columnDefs;
  };

  const onFileUpload = (fileInfo) => {
    const { filename, url } = fileInfo;
    setSelectedSponsor((prev) => ({
      ...prev,
      photoURL: url,
      sponsorPhoto: filename,
    }));
  };

  const onFileDelete = () => {
    setSelectedSponsor((prev) => ({
      ...prev,
      photoURL: null,
      sponsorPhoto: null,
    }));
  };

  const handleSave = async (sponsor) => {
    const updatedSponsor = { ...selectedSponsor, ...sponsor };
    try {
      await saveMutation.mutateAsync(updatedSponsor);
      setShowModal(false);
    } catch {
      /* mutation toast */
    }
  };

  const handleRemove = async () => {
    try {
      await removeMutation.mutateAsync(selectedSponsor.sponsorId);
      setShowModal(false);
      setSelectedSponsor({});
    } catch {
      /* mutation toast */
    }
  };

  const openModal = (sponsor) => {
    const next = sponsors.find((s) => s.sponsorId === sponsor.sponsorId) || {};
    setSelectedSponsor(next);
    setShowModal(true);
  };

  return (
    <>
      <FestivalHeader
        title="Sponsors"
        showExit={true}
        showAdd={true}
        addTitle="Add Sponsor"
        addAction={() => {
          setSelectedSponsor({});
          setShowModal(true);
        }}
      />
      {loading ? (
        <Loading />
      ) : (
        <FilterableTable
          data={sponsors}
          tableTitle=""
          columns={buildColumnDefinitions()}
          includeFilter={false}
          editHandler={openModal}
          toggleModal={openModal}
        />
      )}

      <Portal
        header={
          selectedSponsor
            ? selectedSponsor.sponsorName || 'Add New Sponsor'
            : 'Add New Sponsor'
        }
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <SponsorForm
          sponsor={selectedSponsor}
          handleSave={handleSave}
          handleRemove={handleRemove}
          onFileUpload={onFileUpload}
          onFileDelete={onFileDelete}
        />
      </Portal>
    </>
  );
}
